// Helpers for the entry `media` array (hosted media is proxied by the backend
// at documentation-media/{id} and needs an authenticated fetch — media tags
// cannot send the Authorization header themselves).

const isVideoUrl = (url) => /\.(mp4|webm|mov)(\?.*)?$/i.test(url);
const isImageUrl = (url) => /\.(png|jpe?g|gif|webp|svg)(\?.*)?$/i.test(url);

// Entries from older documentation servers only carry `mediaLinks` (plain URLs)
export const normalizeMedia = (entry) =>
  entry.media ||
  (entry.mediaLinks || []).map((url) => ({
    url,
    isHosted: false,
    mediaType: isVideoUrl(url) ? 'video' : isImageUrl(url) ? 'image' : 'file',
    fileName: url.split('/').pop(),
  }));

export const mediaId = (media) => media.url.split('/').filter(Boolean).pop();

// Canonical id for matching against `media://{uuid}` placeholders; entries from
// older documentation servers have no uuid field, but their url ends in the id
export const mediaUuid = (media) => (media.uuid || mediaId(media)).toLowerCase();

// Hosted media has a relative proxy URL; external links are absolute. The
// explicit isHosted flag is not sent by every documentation-server version.
export const isHostedMedia = (media) =>
  Boolean(media?.isHosted) || !/^https?:\/\//i.test(media?.url || '');

export const formatBytes = (bytes) => {
  if (!bytes) return '';
  if (bytes >= 1048576) return `${(bytes / 1048576).toFixed(1)} MB`;
  return `${Math.max(1, Math.round(bytes / 1024))} KB`;
};
